import { notifyError, notifySuccess } from '@/helpers/notifications';

const copyToClipboard = ({ value }) => {
    const cb = navigator.clipboard;
    cb.writeText(value)
        .then(() => {
            notifySuccess({ title: 'Скопировано' })
        })
        .catch(errors => {
            notifyError({ title: 'Ошибка при копировании', errors: errors })
        });
}

export {copyToClipboard}